var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 17,
    viewBox: "0 0 96 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15468 1.38713V15.6128H1.34728V1.38713H6.15468ZM7.50196 -1.52588e-05H0V17H7.49007V-1.52588e-05H7.50196Z",
    fill: "url(#paint0_linear_164_14468)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6985 1.38714V15.6129H12.8971V1.38714H17.6985ZM19.0458 0H11.5498V17H19.0458V0Z",
    fill: "url(#paint1_linear_164_14468)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8383 17L96 17V0L24.8383 0V17Z",
    fill: "url(#paint2_linear_164_14468)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_14468",
    x1: -46.8575,
    y1: 8.49996,
    x2: -1115.45,
    y2: 8.49996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_164_14468",
    x1: 10756.6,
    y1: 14675.6,
    x2: -2738.59,
    y2: 14675.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_164_14468",
    x1: 102031,
    y1: 14675.6,
    x2: -26085.8,
    y2: 14675.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR3);
export default __webpack_public_path__ + "static/media/r3.2940accc0c1f1aee03b34a7c353e041e.svg";
export { ForwardRef as ReactComponent };